import { Slot } from '@radix-ui/react-slot'
import { motion, useAnimate } from 'motion/react'
import { ReactNode } from 'react'

export const AnimatedController = ({ children }: { children: ReactNode }) => {
    const [scope, animate] = useAnimate()
    const MotionComp = motion.create(Slot)

    return (
        <MotionComp
            ref={scope}
            whileHover="hover"
            animate="initial"
            onHoverEnd={() => animate('path', { x: 0, y: 0, scale: 1 }, { duration: 0.2, damping: 20 })} // Reset animation on hover end
        >
            {children}
        </MotionComp>
    )
}
